import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { AsyncApiService } from '@spike/core';
import { ConfirmationDialogService } from '../../shared/services/confirmation-dialog.service';
import { EtiquetteApiEnum } from 'src/app/config/entity-api.enum';
import { EntityEtiquette } from '../models/entity-etiquette.model';

@Injectable({ providedIn: 'root' })
export class EtiquetteStoreService {
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly asyncApiService = inject(AsyncApiService);
    private readonly etiquetteMap :Map<EtiquetteApiEnum, WritableSignal<EntityEtiquette[]>> = new Map<EtiquetteApiEnum, WritableSignal<EntityEtiquette[]>>([]);


    public async save(apiEnum: EtiquetteApiEnum, entity: EntityEtiquette){
        await this.asyncApiService.save(apiEnum, entity, entity.etiquetteId?? undefined);
        await this.reload(apiEnum);
    }

    
    public async deleteById(apiEnum: EtiquetteApiEnum, id: number) {
        this.confirmationDialogService.show('Sei sicuro di voler eliminare questa etichetta?', async () => {
            await this.deleteByIdConfirmed(apiEnum, id);
        });
    }
    public async deleteByIdConfirmed(apiEnum: EtiquetteApiEnum, id: number) {
        await this.asyncApiService.deleteById(apiEnum, id);
        await this.reload(apiEnum);
    }

   public getList(apiEnum: EtiquetteApiEnum): Signal<EntityEtiquette[]> {
        if (!this.etiquetteMap.has(apiEnum)) {
            this.etiquetteMap.set(apiEnum, signal<EntityEtiquette[]>([]));
            this.reload(apiEnum);
        }
        return this.etiquetteMap.get(apiEnum)!.asReadonly();
    }

    private async reload(apiEnum: EtiquetteApiEnum){
        const res = await this.asyncApiService.selectAll<EntityEtiquette>(apiEnum);
        if (!this.etiquetteMap.has(apiEnum)) {
            this.etiquetteMap.set(apiEnum, signal(res));
        }else{
            this.etiquetteMap.get(apiEnum)!.set(res);

        }
    }
    
    public getReactiveList(apiEnumSignal: Signal<EtiquetteApiEnum>): Signal<EntityEtiquette[]> {
        return computed(() => {
            const api = apiEnumSignal();
            const listSignal = this.getList(api);
            return listSignal();
        });
    }

    public findStatic(apiEnum: EtiquetteApiEnum, id: number | undefined): EntityEtiquette | undefined {
        if (!id) return undefined;        
        const currentList = this.getList(apiEnum)();
        return currentList.find(x => x.etiquetteId === id);
    }
        
    public findReactive<T>(apiEnum: EtiquetteApiEnum, id: number): Signal<EntityEtiquette | undefined> {
        return computed(() => {
            if (!id) return undefined;
            const list = this.getList(apiEnum)();
            const found = list.find(x => x.etiquetteId === id);
            if (!found && list.length > 0) {
                this.reload(apiEnum);
            }

            return found;
        });
    }
    
}